import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import styles from "./addBooking.module.css";
import { Breadcrumbs, Tabs, Tab, Typography, Box, Snackbar, Alert } from "@mui/material";
import Loader from "../../../components/Loader";
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";
import Step4 from "./Step4";
import { authData, withAdminAuth } from "../../../components/GetAuth";
import { useParams } from "react-router-dom";
import axios from "axios";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (<div
    role="tabpanel"
    hidden={value !== index}
    id={`simple-tabpanel-${index}`}
    aria-labelledby={`simple-tab-${index}`}
    {...other}
  >
    {value === index && (
      <Box sx={{ p: 3 }}>
        <Typography>{children}</Typography>
      </Box>
    )}
  </div>);
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return { id: `simple-tab-${index}`, "aria-controls": `simple-tabpanel-${index}` };
}

const AddBooking = () => {
  const auth = authData();
  const API_TOKEN = auth?.api_token;
  const { booking_id } = useParams();
  const [loading, setLoading] = useState(false);
  const [tabValue, setTabValue] = useState(0);
  const [bookingData, setBookingData] = useState({});
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarType, setSnackbarType] = useState("success");

  const [selectPCountry, setSelectPCountry] = useState('GB');
  const [selectDCountry, setSelectDCountry] = useState('GH');

  useEffect(() => {
    if (auth?.company && auth?.company?.pickup_country) {
      setSelectPCountry(auth?.company?.pickup_country);
    }
    if (auth?.company && auth?.company?.delivery_country) {
      setSelectDCountry(auth?.company?.delivery_country);
    }
  }, [auth?.company]);

  useEffect(() => {
    const fetchBooking = () => {
      setLoading(true);
      axios.get(process.env.REACT_APP_API_URL + "v1/bookings/" + booking_id, {
        headers: {
          Authorization: `Bearer ${API_TOKEN}`
        }
      }).then((response) => {
        setLoading(false);
        let bookingDataTemp = response.data.data;

        let products = bookingDataTemp?.products?.map(i => {
          let isFragile = i?.is_fragile === 1 ? true : false;
          let categoryId = i?.parent_id > 0 ? i?.parent_id : i?.product_id;
          let isItem = i?.parent_id > 0 ? true : false;
          return { category_id: categoryId, is_fragile: isFragile, is_item: isItem, item_id: i?.product_id, item_name: i?.product_title, total: i?.sub_amount };
        });

        let pickUpData = { address: bookingDataTemp?.pickup_details?.address, customer_id: bookingDataTemp?.pickup_details?.user_id, email: bookingDataTemp?.pickup_details?.email, latitude: parseFloat(bookingDataTemp?.pickup_details?.latitude), longitude: parseFloat(bookingDataTemp?.pickup_details?.longitude), name: bookingDataTemp?.pickup_details?.name, phone: bookingDataTemp?.pickup_details?.phone, post_code: bookingDataTemp?.pickup_details?.post_code };

        let recipientData = { address: bookingDataTemp?.recipient_details?.address, customer_id: bookingDataTemp?.recipient_details?.user_id, email: bookingDataTemp?.recipient_details?.email, latitude: parseFloat(bookingDataTemp?.recipient_details?.latitude), longitude: parseFloat(bookingDataTemp?.recipient_details?.longitude), name: bookingDataTemp?.recipient_details?.name, phone: bookingDataTemp?.recipient_details?.phone };

        setBookingData(prev => {
          return { ...prev, customer_id: bookingDataTemp?.customer_id, registered_company: bookingDataTemp?.registered_company, insurance: bookingDataTemp?.insurance, company_name: bookingDataTemp?.company_name, company_shipping: bookingDataTemp?.company_shipping, pickup_date: bookingDataTemp?.pickup_date, notes: bookingDataTemp?.description, products: products, pickUpData: pickUpData, recipientData: recipientData, discountVal: bookingDataTemp?.discount_val, discountAmount: bookingDataTemp?.discount_amount };
        })
      }).catch((error) => {
        setLoading(false);
      });
    }

    if (booking_id) {
      fetchBooking();
    }
  }, [booking_id, API_TOKEN]);

  const saveStep1Data = (data) => {
    let bookingDataTemp = bookingData;
    bookingDataTemp = { ...bookingDataTemp, ...data };

    setBookingData(bookingDataTemp);
    setTabValue((prevValue) => prevValue + 1);
  };

  const saveStep2Data = (pickUpData) => {
    let bookingDataTemp = bookingData;
    bookingDataTemp = { ...bookingDataTemp, pickUpData: pickUpData };

    setBookingData(bookingDataTemp);
    setTabValue((prevValue) => prevValue + 1);
  };

  const saveStep3Data = (recipientData) => {
    let bookingDataTemp = bookingData;
    bookingDataTemp = { ...bookingDataTemp, recipientData: recipientData };

    setBookingData(bookingDataTemp);
    setTabValue((prevValue) => prevValue + 1);
  };

  const backToTab = () => {
    document.documentElement.scrollTo({ top: 0, left: 0, behavior: "instant" });

    setTabValue((prevValue) => prevValue - 1);
  };

  return (<>
    <Loader open={loading} setOpen={setLoading.bind(this)} />

    <div className={`${styles.MainDiv}`}>
      <div className={`${styles.PageTitleWrap}`}>
        <p className={`${styles.PageTitle}`}>Booking</p>
        <Breadcrumbs aria-label="breadcrumb" className="breadcrumb">
          <Typography color="text.primary">Booking</Typography>
          <Typography color="text.primary">{booking_id ? 'Edit' : 'Add'}</Typography>
        </Breadcrumbs>
      </div>

      <div className={`${styles.MainCard}`}>
        <Box sx={{ width: "100%" }} className="AddBookingTab">
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs value={tabValue} aria-label="basic tabs example">
              <Tab label="Parcel Details" {...a11yProps(0)} />
              <Tab label="Pickup Address" {...a11yProps(1)} />
              <Tab label="Recipient Address" {...a11yProps(2)} />
              <Tab label="Order Summary" {...a11yProps(3)} />
            </Tabs>
          </Box>

          <TabPanel value={tabValue} index={0}>
            <Step1 saveStep1Data={saveStep1Data.bind(this)} bookingData={bookingData} />
          </TabPanel>
          <TabPanel value={tabValue} index={1}>
            <Step2 saveStep2Data={saveStep2Data.bind(this)} backToTab={backToTab.bind(this)} bookingData={bookingData} selectCountry={selectPCountry} />
          </TabPanel>
          <TabPanel value={tabValue} index={2}>
            <Step3 saveStep3Data={saveStep3Data.bind(this)} backToTab={backToTab.bind(this)} bookingData={bookingData} selectCountry={selectDCountry} />
          </TabPanel>
          <TabPanel value={tabValue} index={3}>
            <Step4 booking_id={booking_id} bookingData={bookingData} backToTab={backToTab.bind(this)} setLoading={setLoading.bind(this)} setSnackbarMessage={setSnackbarMessage.bind(this)} setSnackbarType={setSnackbarType.bind(this)} setSnackbarOpen={setSnackbarOpen.bind(this)} />
          </TabPanel>
        </Box>
      </div>
    </div>

    <Snackbar
      open={snackbarOpen}
      autoHideDuration={6000}
      onClose={(e) => setSnackbarOpen(false)}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <Alert
        onClose={(e) => setSnackbarOpen(false)}
        severity={snackbarType}
        variant="filled"
        sx={{ width: "100%" }}
      >
        {snackbarMessage}
      </Alert>
    </Snackbar>
  </>);
};

export default withAdminAuth(AddBooking);